<template>
  <svg :class="'icon'" width="403.32" height="63.53" viewBox="0 0 403.32 63.53">
    <g>
      <g>
        <path
          id="o"
          d="m380.2,31.73c0,4.77-3.87,8.64-8.64,8.64s-8.64-3.87-8.64-8.64,3.87-8.64,8.64-8.64,8.64,3.87,8.64,8.64"
          :fill="color"
        />
        <path
          id="O-2"
          d="m371.56,52.48c-11.49,0-20.81-9.32-20.81-20.81s9.32-20.81,20.81-20.81,20.81,9.32,20.81,20.81-9.32,20.81-20.81,20.81m0-52.48c-17.56,0-31.77,14.21-31.77,31.77s14.21,31.77,31.77,31.77,31.77-14.21,31.77-31.77S389.12,0,371.56,0"
          :fill="color"
        />
      </g>
      <path
        id="T"
        d="m288.27,11.87h19.91v50.68h11.37V11.87h19.91V1.29h-51.19v10.58Z"
        :fill="color"
      />
      <path
        id="R"
        d="m272.9,21.52v.46c0,5.97-4.77,9.82-12.16,9.82h-15.28V11.79h15.19c7.78,0,12.25,3.55,12.25,9.74m-2.73,17.94c9.15-2.79,14.19-9.36,14.19-18.54v-.17c0-5.27-1.77-9.87-5.12-13.31-4.12-4.03-10.25-6.15-17.72-6.15h-27.35v61.27h11.28l-.07-19.35h12.63l19.39,19.35h15.25l-22.49-23.1Z"
        :fill="color"
      />
      <path
        id="A"
        d="m183.54,31.69v-5.52c0-8.08,6.55-14.63,14.63-14.63s14.63,6.55,14.63,14.63v5.52h-29.25ZM198.17.09c-14.42,0-26.08,11.66-26.08,26.08v36.39h11.46v-19.41h29.25v19.41h11.46V26.17c.1-14.32-11.66-26.08-26.08-26.08"
        :fill="color"
      />
      <path
        id="K"
        d="m140.9,35.37c-.91-.91-1.42-2.13-1.42-3.45s.51-2.54,1.42-3.45L167.28,1.3h-15.83l-18.66,19.21c-1.84,1.87-3.18,4.11-3.94,6.55V1.29h-11.83v61.26h11.83v-25.78c.76,2.44,2.09,4.69,3.94,6.55l18.67,19.22h15.83l-26.39-27.18Z"
        :fill="color"
      />
      <path
        id="A-2"
        d="m66.57,31.69v-5.52c0-8.08,6.55-14.63,14.63-14.63s14.63,6.55,14.63,14.63v5.52h-29.25ZM81.2.09c-14.32,0-26.08,11.76-26.08,26.08v36.39h11.46v-19.41h29.25v19.41h11.46V26.17C107.38,11.85,95.62.09,81.2.09"
        :fill="color"
      />
      <path
        id="J"
        d="m34,35.04c0,8.93-7.21,16.14-16.14,16.14H0v11.37h17.86c15.12,0,27.51-12.28,27.51-27.51V1.25h-11.37v33.8Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script setup>
defineProps({
  /**
   * color of the icon
   */
  color: String
})
</script>

<style lang="scss" scoped></style>